import React from "react";
import { CSSProperties } from "react";
import { ShimmerLine } from "../../../../../components/Shimmer/ShimmerLine/ShimmerLine";
import { ShimmerElementProps } from "../../../../../shared/props";

const lineHeight = 12;
const pillShimmerStyle: CSSProperties = {
    display: "inline-block",
    marginRight: "8px"
};

export interface PillShimmerProps extends ShimmerElementProps {
    readonly charactersInPill: number;
}

export const PillShimmer: React.FC<PillShimmerProps> = ({
    charactersInPill
}) => {
    const letterWidth = 6;
    const padding = 40;

    const shimmerWidth = `${padding + charactersInPill * letterWidth}px`;
    return (
        <span style={pillShimmerStyle}>
            <ShimmerLine width={shimmerWidth} height={lineHeight} />
        </span>
    );
};
